import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "header" }
const _hoisted_2 = { id: "header-area" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "brand-mark",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M3 8h11a3 3 0 1 0-3-3" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M3 12h15a3 3 0 1 1-3 3" }),
    /*#__PURE__*/_createElementVNode("path", { d: "M3 16h9" })
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "brand-word" }, [
  /*#__PURE__*/_createTextVNode("breez"),
  /*#__PURE__*/_createElementVNode("b", null, "er")
], -1)
const _hoisted_5 = { id: "service-area" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "home-link",
        "aria-label": "Breezer 홈"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (service.external)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: service.path,
                  class: "service"
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(service.name), 1)
                ], 8, _hoisted_6))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: service.path,
                  class: "service"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(service.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
          ], 64))
        }), 128))
      ])
    ])
  ]))
}